import React from "react";
import { Navigate, RouteProps } from "react-router-dom";
import UsersViewModel from "../../viewmodels/UsersViewModel";
import { observer } from "mobx-react-lite";
import { CircularProgress, Box } from "@material-ui/core";

export type ProtectedRouteProps = RouteProps & {
  allowedProfiles: String[];
  component: JSX.Element
}

const ProtectedRouteComponent = observer((props: ProtectedRouteProps) => {
  const vmUsers = UsersViewModel.getInstance();
  const [isChecking, setIsChecking] = React.useState(true);
  
  React.useEffect(() => {
    // Ensure user is loaded from localStorage on mount
    const currentUser = vmUsers?.currentUser;
    
    console.log('[ProtectedRoute] Initial check - currentUser:', currentUser);
    
    if (!currentUser || !currentUser.email) {
      console.log('[ProtectedRoute] Attempting to load from localStorage');
      const loaded = vmUsers.loadLocalStorageUser();
      console.log('[ProtectedRoute] Loaded from localStorage:', loaded);
    }
    
    setIsChecking(false);
  }, [vmUsers]);
  
  if (isChecking) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  const finalUser = vmUsers?.currentUser;
  
  console.log('[ProtectedRoute] Final check - user:', finalUser);
  console.log('[ProtectedRoute] Allowed profiles:', props.allowedProfiles);
  
  const hasToken = finalUser?.email && finalUser?.token;
  const userRole = finalUser?.role;
  
  // Check if user has an allowed role (compare case-insensitive for safety)
  const hasAllowedRole = props.allowedProfiles.length === 0 || 
    props.allowedProfiles.some((profile) => {
      const profileStr = String(profile).toLowerCase();
      const userRoleStr = String(userRole).toLowerCase();
      return profileStr === userRoleStr;
    });
  
  console.log('[ProtectedRoute] hasToken:', hasToken, 'hasAllowedRole:', hasAllowedRole, 'userRole:', userRole);
  
  if (hasToken && hasAllowedRole) {
    console.log('[ProtectedRoute] Access granted');
    return props.component;
  } else {
    console.log('[ProtectedRoute] Access denied - Redirecting to login');
    return <Navigate to="/login" replace />;
  }
});

export const protectedRoute = (props: ProtectedRouteProps) => {
  return <ProtectedRouteComponent {...props} />;
};

export default protectedRoute;
